<article
  *ngIf="vm$ | async as vm"
  class="lum-page lum-page__card  lum-c-transfer-order-view"
>
  <header class="lum-page-header">
    <h2 class="lum-page-header__heading">
      <a routerLink="/inventory/transfer-order/list">Transfer Orders</a> /
      <ng-container *ngIf="vm.transferOrder; else loadingOrError">
        {{ vm.transferOrder.orderNumber }}
      </ng-container>
      <ng-template #loadingOrError>
        <ng-container *ngIf="vm.loading">Loading…</ng-container>
        <ng-container *ngIf="vm.error">Error</ng-container>
      </ng-template>
    </h2>
    <div class="lum-page-header__actions" *ngIf="vm.transferOrder">
      <a
        class="lum-button lum-button--secondary"
        [attr.aria-disabled]="!vm.canEdit"
        [tabindex]="vm.canEdit ? 0 : -1"
        [routerLink]="
          vm.canEdit
            ? ['/inventory/transfer-order', vm.transferOrder.id, 'edit']
            : null
        "
        (click)="!vm.canEdit && $event.preventDefault()"
      >
        <i class="fas fa-edit"></i>
        Edit
      </a>
    </div>
  </header>

  <div class="lum-page-content">
    <ng-container *ngIf="!vm.loading; else whenLoading">
      <ng-container *ngIf="vm.error">
        <div class="alert alert-danger">{{ vm.error }}</div>
      </ng-container>
      <ng-container *ngIf="vm.transferOrder">
        <dl class="d-flex gap-x-5 align-items-baseline flex-wrap">
          <div
            *ngIf="
              vm.transferOrder.sourceWarehouse &&
              vm.transferOrder.destinationWarehouse
            "
            class="order-0"
          >
            <dt class="lum-label">Warehouses</dt>
            <dd class="h5">
              {{ vm.transferOrder.sourceWarehouse.locationName }}
              →
              {{ vm.transferOrder.destinationWarehouse.locationName }}
            </dd>
          </div>
          <div class="flex-grow-1 flex-md-grow-0 order-1 order-md-12  text-right">
            <dt class="lum-label">Status</dt>
            <dd>
              <span
                class="lum-chip lum-chip--label lum-chip--small"
                [class.lum-chip--primary]="
                  vm.transferOrder.orderStatus === EOrderTransferStatus.POSTED
                "
              >
                {{ vm.transferOrder.orderStatus || vm.transferOrder.status }}
              </span>
            </dd>
          </div>
          <div class="w-p100 d-md-none order-2"></div>
          <div *ngIf="vm.transferOrder?.salesOrder?.id" class="order-3">
            <dt class="lum-label">Sales Order</dt>
            <dd>
              <a
                [routerLink]="[
                  '/shipping/posted-orders',
                  vm.transferOrder.salesOrder.id,
                ]"
              >
                {{ vm.transferOrder.salesOrder.orderNumber }}
              </a>
            </dd>
          </div>
          <div *ngIf="vm.transferOrder?.supplierPurchaseOrder?.id" class="order-3">
            <dt class="lum-label">Purchase Order</dt>
            <dd>
              <a
                [routerLink]="[
                  '/orders',
                  vm.transferOrder.supplierPurchaseOrder.id,
                ]"
              >
                PO #{{ vm.transferOrder.supplierPurchaseOrder.id }}
              </a>
            </dd>
          </div>
          <div class="order-3">
            <dt class="lum-label">Shipping Cost</dt>
            <dd>{{ vm.transferOrder.shippingCost | currency }}</dd>
          </div>
          <div class="flex-grow-1 order-4 order-md-11  text-right">
            <dt class="lum-label">Created</dt>
            <dd>{{ vm.transferOrder.createdAt | date: 'medium' }}</dd>
          </div>
        </dl>

        <section *ngIf="vm.transferOrder && vm.transferOrder.orderItems?.length">
          <h6>Items</h6>
          <ag-grid-angular
            class="ag-theme-alpine ag-theme-lum ag-theme-lum--next"
            [rowData]="vm.transferOrder.orderItems"
            [columnDefs]="agColumnDefs"
            [gridOptions]="agGridOptions"
            domLayout="autoHeight"
          />
        </section>
      </ng-container>
    </ng-container>
    <ng-template #whenLoading>
      <div class="h5">Loading transfer order…</div>
    </ng-template>
  </div>
</article>
